<script setup>
import { CheckIcon } from '@heroicons/vue/24/outline'

import BrandButton from '@/components/ui/BrandButton.vue'
import SectionHeading from '@/components/ui/SectionHeading.vue'
import { usePlanSelection } from '@/composables/usePlanSelection'
import { plans } from '@/data/services'

const { selectPlan } = usePlanSelection()
</script>

<template>
    <section
        class="bg-white py-24 md:py-32"
        id="sluzby"
    >
        <div class="mx-auto max-w-7xl px-6 lg:px-10">
            <header class="max-w-3xl">
                <SectionHeading
                    title="Služby"
                    lede="Vedení účetnictví už od 500 Kč měsíčně. Konkrétní cena je vždy individuální podle rozsahu — rádi se domluvíme."
                />
            </header>

            <div class="mt-16 grid gap-6 md:grid-cols-2 md:gap-8">
                <article
                    class="flex flex-col rounded-2xl border border-zinc-200 bg-white p-8 md:p-10"
                    v-for="plan in plans"
                    :key="plan.id"
                >
                    <h3 class="text-brand-900 text-2xl font-extrabold tracking-tight md:text-3xl">
                        {{ plan.heading }}
                    </h3>

                    <p class="mt-3 text-base leading-relaxed text-zinc-600">
                        {{ plan.description }}
                    </p>

                    <p class="text-brand-900 mt-8 text-3xl font-extrabold tracking-tight md:text-4xl">
                        {{ plan.price }}
                    </p>

                    <ul class="mt-8 space-y-3 text-base text-zinc-700">
                        <li
                            class="flex items-start gap-3"
                            v-for="feature in plan.features"
                            :key="feature"
                        >
                            <CheckIcon
                                class="text-brand-900 mt-0.5 size-5 shrink-0"
                                stroke-width="2"
                                aria-hidden="true"
                            />
                            <span>
                                {{ feature }}
                            </span>
                        </li>
                    </ul>

                    <div class="mt-10 flex-1" />

                    <BrandButton
                        class="mt-2"
                        href="#contact"
                        block
                        @click="
                            selectPlan({
                                id: plan.id,
                                type: 'plan',
                                name: plan.heading,
                                price: plan.price,
                            })
                        "
                    >
                        Mám zájem
                    </BrandButton>
                </article>
            </div>
        </div>
    </section>
</template>
